import { createAction } from '@reduxjs/toolkit'
import { FundsData } from 'store/link/types'

export const updateConnected = createAction<{ connected: boolean }>(
  'link/updateConnected',
)
export const updateFunds = createAction<{
  funds: { [index: string]: FundsData }
}>('link/updateFunds')
export const updatePortfolio = createAction<{ portfolio: any[] }>(
  'link/updatePortfolio',
)
export const updateAccountLockState = createAction<{ isLocked: boolean }>(
  'link/updateAccountLockState',
)
export const disconnectLink = createAction('link/disconnectLink')
export const updateActivating = createAction<{ activating: boolean }>(
  'link/updateActivating',
)
